import * as React from 'react';
import PaymentIcon from './PaymentIcon';
import Formatter from './Formatter';

interface PaymentInfoProps {
  brandName: string;
  brand: string;
  last4Digits: string;
  type: string;
  expMonth?: string;
  expYear?: string;
}

export default function PaymentInfo(props: PaymentInfoProps) {
  const { brand = 'NEWBANK', brandName = 'New Bank' } = props;
  return (
    <>
      <PaymentIcon
        brand={brand}
        brandName={brandName}
        style={{ verticalAlign: `middle` }}
      />
      &nbsp;
      {props.type.toLowerCase() === 'paypal' ? (
        props.last4Digits
      ) : (
        <Formatter
          type={
            ['eft', 'bankaccount'].includes(props.type.toLowerCase())
              ? 'bankaccount'
              : 'card'
          }
          format={brand}
          value={
            props.last4Digits.length > 4
              ? props.last4Digits
              : `000000${props.last4Digits}`
          }
        />
      )}
      {!!props.expMonth && !!props.expYear && (
        <span style={{ float: 'right' }}>{`${props.expMonth.padStart(
          2,
          '0'
        )} / ${props.expYear.slice(-2)}`}</span>
      )}
    </>
  );
}
